import Icon from '../components/Icon.vue'

Icon.register({
  'sign-language': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M91.4 484c-0.3-16 13.1-29.1 29.1-29.1h62.3v-5.7h-125.9c-16 0-29.4-13.1-29.1-29.1 0.3-15.5 13-28 28.6-28h126.4v-5.7h-153.7c-16 0-29.4-13.1-29.1-29.1 0.3-15.5 13-28 28.6-28h154.3v-5.7h-125.2c-16 0-29.4-13.1-29.1-29.1 0.3-15.5 13-28 28.6-28h168.6l-31.1-22.6c-12.8-9.3-15.6-27.1-6.3-39.9 9.3-12.8 27.1-15.6 39.9-6.3l123.4 89.7c7.8 5.7 14.1 18.1 14.1 27.7v141.1c0 15.9-10.9 29.7-26.4 33.4l-80.5 18.9c-8.6 2-22.6 3.6-31.4 3.6h-107.4c-15.6 0-28.3-12.5-28.6-28zM164.7 258.3l-36.4-46.7c-9.6-12.3-7.5-30 4.6-39.8 12.5-10.1 31-7.6 40.9 5.1l13 16.7c-17.1 15.6-15.4 43 3.2 56.5l11.2 8.1h-36.4zM448 256.2c0 0.3 0 0.8 0 1.1 0 9.2-5.9 21.4-13.2 27.1l-61.1 47.5v-17c0-13.5-6.5-26.3-17.4-34.2l-123.4-89.7c-12.6-9.2-29.2-9.2-41.7-0.9l-52.1-66.8c-9.8-12.6-7.7-31.3 5.1-40.9 12.4-9.3 30.1-7 39.7 5.3l77.7 99.8 4.5-3.5-94.4-121.3c-9.8-12.6-7.7-31.3 5.1-40.9 12.4-9.3 30.1-7 39.7 5.3l94.8 121.7 4.5-3.5-76.9-98.7c-9.8-12.6-7.7-31.3 5.1-40.9 12.4-9.3 30.1-7 39.7 5.3l103.6 133-1.3-38.4c-0.5-15.8 11.8-29 27.6-29.5 15.8-0.5 29 11.8 29.5 27.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sign-language.js
// module id = 1890
// module chunks = 0